export const PROJECT = {
    DOMAIN : 'www.petsandsavings.com'
}